






























import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
  name: 'Footer',

  components: {},

  data: () => ({
    last_updated: null,
  }),

  methods: {
    async getStats() {
      try {
        const resp = await axios.get(this.statsUrl);
        const date = new Date(resp.data.last_updated);
        // @ts-ignore
        this.last_updated = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
      } catch (error) {
        window.console.log(`Stats from the server: ${error}`);
      }
    },
  },

  computed: {
    statsUrl(): string {
      return `${this.$store.state.baseBackendUrl}api/v1/stats`;
    },
  },

  async mounted() {
    this.getStats();
  },
});
